import { createContext } from "react";

const LocalesContext = createContext({
  slug: "",
  avaiableLangs: [],
  pageNumber: 0,
});

export default LocalesContext;
